import React, { memo, useCallback, useMemo } from "react";
import { useAuth } from "modules/providers/auth-provider";
import SyncoTooltip from "modules/_shared/synco-tooltip";
import useUserPreference from "modules/hooks/use-user-preference";
import { Switch } from "@chakra-ui/react";

const MeToggleSmsButton = () => {
  const { me } = useAuth();
  const {
    booleanValue: isSms,
    upsertUserPreference: onSmsTextDeliveryToggled,
  } = useUserPreference({
    userId: me?.id,
    name: "SMS",
  });

  const isSmsDisabled = useMemo(() => !me?.phone, [me?.phone]);

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!me) return;
      onSmsTextDeliveryToggled(e.target.checked);
    },
    [me, onSmsTextDeliveryToggled],
  );

  return (
    <SyncoTooltip
      label={
        isSmsDisabled
          ? "You must have a valid phone number to enable SMS"
          : undefined
      }
    >
      <Switch
        size="sm"
        defaultChecked={isSms}
        onChange={onChange}
        isDisabled={isSmsDisabled}
      />
    </SyncoTooltip>
  );
};

export default memo(MeToggleSmsButton);
